/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelStockSplitJobRequest} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'
import {CancelStockSplitJobResponse} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'


export const cancelStockSplitJob = (request:CancelStockSplitJobRequest, options?: CashRequestOptions) => post<CancelStockSplitJobRequest, CancelStockSplitJobResponse>("/2.0/cash/cancel-stock-split-job", request, {...options, rejectOnError: true })